import { Redirect, Slot } from "expo-router";

import useAPI from "@/src/contexts/api-context";

export default function Layout() {
  const { isLoggedIn } = useAPI();

  if (!isLoggedIn) return <Redirect href="/login" />;

  return <Slot />;
}
